import React, { lazy, useEffect } from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SmartCookingSection } from './components/SmartCookingSection';
import { SolutionSection } from './components/SolutionSection';
import { DeferredSection } from './components/DeferredSection';
import { CtaButton } from './components/CtaButton';
import { initializeMetaPixel } from './utils/metaPixel';
const RecipeGallerySection = lazy(() => import('./components/RecipeGallerySection').then(({
  RecipeGallerySection: Component
}) => ({
  default: Component
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(({
  BonusSection: Component
}) => ({
  default: Component
})));
const SavingsSection = lazy(() => import('./components/SavingsSection').then(({
  SavingsSection: Component
}) => ({
  default: Component
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(({
  TestimonialsSection: Component
}) => ({
  default: Component
})));
const HappyFamiliesCarousel = lazy(() => import('./components/HappyFamiliesCarousel').then(({
  HappyFamiliesCarousel: Component
}) => ({
  default: Component
})));
const OfferSection = lazy(() => import('./components/OfferSection').then(({
  OfferSection: Component
}) => ({
  default: Component
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(({
  GuaranteeSection: Component
}) => ({
  default: Component
})));
const FaqSection = lazy(() => import('./components/FaqSection').then(({
  FaqSection: Component
}) => ({
  default: Component
})));
const Footer = lazy(() => import('./components/Footer').then(({
  Footer: Component
}) => ({
  default: Component
})));
const PurchasePopup = lazy(() => import('./components/PurchasePopup').then(({
  PurchasePopup: Component
}) => ({
  default: Component
})));
export function App() {
  useEffect(() => {
    const startPixel = () => window.setTimeout(initializeMetaPixel, 2500);
    const idleCallback = window.requestIdleCallback?.(startPixel, {
      timeout: 5000
    });
    if (!idleCallback) {
      const timeout = startPixel();
      return () => window.clearTimeout(timeout);
    }
    return () => window.cancelIdleCallback?.(idleCallback);
  }, []);
  return <div className="w-full min-h-full bg-white font-sans text-neutral-900 antialiased" data-id="element-0" data-mp="d45vg8zbmlp7">
      <Hero data-id="element-1" data-mp="86w3omoglxy7" />
      <PainSection data-id="element-2" data-mp="86cmj86mvdl8" />
      <SmartCookingSection data-id="element-3" data-mp="83qi3hf1he78" />
      <SolutionSection data-id="element-4" data-mp="3gkv2dw2tfxfe" />
      <DeferredSection minHeight={520} data-id="element-5" data-mp="3gm64zskiyz4x"><RecipeGallerySection data-id="element-6" data-mp="3gja7u6gi4ehj" /></DeferredSection>
      <DeferredSection minHeight={420} data-id="element-7" data-mp="3bn2ye3owckuu"><BonusSection data-id="element-8" data-mp="3bnuvjiy56qn8" /></DeferredSection>
      <DeferredSection minHeight={320} data-id="element-9" data-mp="3qb7jfebf98gs"><SavingsSection data-id="element-10" data-mp="3qc97cjdjdpfx" /></DeferredSection>
      <DeferredSection minHeight={520} data-id="element-11" data-mp="3qdai0mqn49x4"><TestimonialsSection data-id="element-12" data-mp="3lkr57rzs1itd" /></DeferredSection>
      <DeferredSection minHeight={420} data-id="element-13" data-mp="3liwl2fwbxuqc"><HappyFamiliesCarousel data-id="element-14" data-mp="3limqsg4951eu" /></DeferredSection>
      <DeferredSection minHeight={520} data-id="element-15" data-mp="2xtv7yfcjxveq"><OfferSection data-id="element-16" data-mp="2xssga57enoxr" /></DeferredSection>
      <DeferredSection minHeight={320} data-id="element-17" data-mp="2swbtbebxzgm9"><GuaranteeSection data-id="element-18" data-mp="2sv0r3iy5agx9" /></DeferredSection>
      <DeferredSection minHeight={360} data-id="element-19" data-mp="2stza6xug707m"><FaqSection data-id="element-20" data-mp="18dhqo0l5eu4f" /></DeferredSection>

      {/* CTA final de cierre */}
      <section className="w-full bg-green-600 py-10 sm:py-14" data-id="element-21" data-mp="1d4hod823dg7z">
        <div className="mx-auto max-w-2xl px-4 text-center sm:px-6" data-id="element-22" data-mp="1d5srd5npqjy1">
          <h2 className="text-2xl font-black leading-tight text-white sm:text-3xl" data-id="element-23" data-mp="ygmuvpg9f7tu">
            Tu Air Fryer está esperando. Empezá a comer como en un bodegón hoy mismo.
          </h2>
          <p className="mt-3 text-green-50" data-id="element-24" data-mp="1r3r0nwn6fq6o">
            250 recetas + 5 bonos por un único pago de $14.990 ARS.
          </p>
          <div className="mt-8 rounded-2xl bg-white p-4" data-id="element-25" data-mp="1w2122ozhvn0q">
            <CtaButton data-id="element-26" data-mp="1i3ujeg349tln" />
          </div>
        </div>
      </section>

      <DeferredSection minHeight={100} data-id="element-27" data-mp="1i5nh35vr53hi"><Footer data-id="element-28" data-mp="1m4weckq03jht" /></DeferredSection>
      <DeferredSection minHeight={0} data-id="element-29" data-mp="1m3uxfzmb02s6"><PurchasePopup data-id="element-30" data-mp="1m790la2skg0o" /></DeferredSection>
    </div>;
}